import styled from 'styled-components';
import { Screens } from 'core/CssVariables';
import {
  AuthFlowColors,
  AuthFlowFont,
  AuthFlowFooterFont,
} from '../authFlow.constants';

export const SAuthFlowLayout = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: ${AuthFlowColors.pageBg};
  font-family: ${AuthFlowFont};

  .auth-flow__hero {
    position: relative;
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px 32px;
    overflow: hidden;
    border-top: 1px solid ${AuthFlowColors.heroStroke};
    /* Figma hero background: ~114px blue square grid ("graph paper") with a
       radial blue glow at top-center that fades toward the edges. Matches the
       "Grid" SVG (radial #387FF5 @ 15%) + coarse grid lines from the design.
       CSS reproduction — responsive & light vs the fixed-size Figma SVG. */
    background-image: radial-gradient(
        75% 55% at 50% 0%,
        rgba(56, 127, 245, 0.12),
        transparent 70%
      ),
      linear-gradient(rgba(56, 127, 245, 0.1) 1px, transparent 1px),
      linear-gradient(90deg, rgba(56, 127, 245, 0.1) 1px, transparent 1px);
    background-size: 100% 100%, 114px 114px, 114px 114px;
    background-position: center top;
  }
  /* Fade the grid out toward the edges so it reads as a soft backdrop. */
  .auth-flow__hero::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(
      120% 90% at 50% 0%,
      transparent 40%,
      ${AuthFlowColors.pageBg} 85%
    );
    pointer-events: none;
  }

  /* Wrapper whose transform:scale is set from JS to fit the viewport,
     preserving the design's proportions (ZEST-738 auto-scale). */
  .auth-flow__scale {
    position: relative;
    z-index: 1;
    transform-origin: center center;
    transition: transform 0.05s ease-out;
  }

  .auth-flow__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
  }

  .auth-flow__logo {
    height: 28px;
    width: auto;
    color: ${AuthFlowColors.navy};
    user-select: none;
  }

  .auth-flow__heading {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    text-align: center;
  }
  .auth-flow__title {
    margin: 0;
    font: 700 32px/1.1 ${AuthFlowFont};
    color: ${AuthFlowColors.navyText};
  }
  .auth-flow__subtitle {
    margin: 0;
    font: 500 18px/1.2 ${AuthFlowFont};
    color: ${AuthFlowColors.link};
  }

  .auth-flow__footer {
    flex-shrink: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 12px 24px;
    padding: 24px 32px;
    border-top: 1px solid ${AuthFlowColors.heroStroke};
  }
  .auth-flow__copyright {
    font: 400 14px/1.4 ${AuthFlowFont};
    color: ${AuthFlowColors.footerText};
  }
  .auth-flow__footer-links {
    display: flex;
    gap: 24px;
  }
  .auth-flow__footer-links a {
    font: 500 14px/1.26 ${AuthFlowFooterFont};
    color: ${AuthFlowColors.footerLink};
  }

  @media (max-width: ${Screens.ScreensSM}) {
    .auth-flow__hero {
      padding: 16px;
    }
  }
`;
